import React, { Component } from "react";
import { Checkbox } from "antd";
import styled from "react-emotion";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { isValidSize, getImageInfo } from "../../../utils/helpers";

/**
 *  ------------- Styles
 */

const ImageWrapper = styled("div")(props => ({
  border: !props.valid ? "1px solid #999" : "",
  position: "relative",
}));

const ImageWrapperWithOpacity = styled("div")({
  marginBottom: "6px",
  opacity: 0.6,
  img: {
    width: "100%"
  }
});

const Usage = styled("div")({
  textAlign: "center",
  span: {
    fontSize: "12px",
    fontWeight: "bold"
  }
});

const NotValid = styled("div")({
  width: "90%",
  maxHeight: "250px",
  margin: "auto",
  p: {
    paddingTop: "100px",
    textAlign: "center"
  }
});

/**
 *  ------------- Component
 */

class CropImage extends Component {
  imagePreviewCanvasRef = React.createRef();
  state = {
    checked: this.props.checked,
    crop: this.props.crop,
    valid: false,
    width: "",
    height: ""
  };

  componentDidMount() {
    const { image, type } = this.props;
    getImageInfo(image).then(res => {
      const result = isValidSize(type, res.width, res.height);
      this.setState({
        width: res.width,
        height: res.height,
        valid: result
      });
    });
  }

  onCropChange = crop => {
    this.setState({ crop });
  };

  onCropComplete = crop => {
    this.props.onCropComplete(this.imageRef, crop, this.props.index);
  };

  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCheckBoxChange = () => {
    this.setState(
      {
        checked: !this.state.checked
      },
      () => {
        this.props.onCheckBoxChange(this.props.index, this.state.checked);
      }
    );
  };

  render() {
    const { width, height, valid } = this.state;
    return (
      <ImageWrapper valid={valid}>
        {valid ? (
          this.state.checked ? (
            <ReactCrop
              src={this.props.image.url}
              crop={this.state.crop}
              locked={true}
              title={"test"}
              disabled={!this.state.valid}
              onImageLoaded={this.onImageLoaded}
              onChange={this.onCropChange}
              onComplete={this.onCropComplete}
            />
          ) : (
            <ImageWrapperWithOpacity>
              <img
                src={this.props.image.url}
                alt="cropped"
                id={this.props.image.uid}
              />
            </ImageWrapperWithOpacity>
          )
        ) : (
          <NotValid>
            {" "}
            <p> Not suitable for {this.props.type.shape} format </p>{" "}
          </NotValid>
        )}

        <Usage
          title={
            !valid
              ? `Image size ${width} x ${height} doesn't match required size`
              : ""
          }
        >
          <Checkbox
            title="Not suitable for logo (4:1) format"
            checked={this.state.checked}
            disabled={!valid}
            style={!valid ? { display: "none" } : null}
            onChange={this.onCheckBoxChange}
          >
            <span>{this.props.text}</span>
          </Checkbox>
        </Usage>
      </ImageWrapper>
    );
  }
}

export default CropImage;
